/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { faChartArea, faCity, faDrawPolygon, faEye, faEyeSlash, faFlag, faFloppyDisk, faLocationPinLock, faMapLocation, faRedo, faRefresh, faSearch, faSpaceShuttle, faSync, faUndo } from '@fortawesome/free-solid-svg-icons';
import { GoogleMap, Marker, Polygon, Polyline } from '@react-google-maps/api';
import { kinks, polygon as turfPolygon } from '@turf/turf';

//ASSETS
import Icons from '../Icons';

//APP
import { geralKmlPolygon } from '../gerarKml';
import { postTalhao, putTalhao } from '../../services/Talhao';
import { postTalhaoCultivavel, putTalhaoCultivavel } from '../../services/TalhaoSafra';
import { buscaCidade, calculoAreaCoord, centerMap, listUf, polyGetPath } from '../../services/Afins';
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../utils/alert';
import { Content } from './styles';
import { Select } from '../CustomUi/Select';
import { Switcher } from '../CustomUi/Switcher';
import Input from '../CustomUi/input';
import ButtonCustom from '../ButtonCustom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '../CustomUi/box';
import { Inline } from '../CustomUi/inline';
import { TitleH4 } from '../CustomUi/titleH4';
import { TitleH3 } from '../CustomUi/titleH3';
import { DeleteButton } from '../CustomUi/deleteButton';

export interface TypesDesenhoTalhao {
    propriedade: number
    update: number
    visible?: boolean
    onClose?: (data: boolean) => void
    atualizar: (codPro: number, nome: string) => void
    cultivavel: boolean
    dataPolygon?: {
        coordenadas?: google.maps.LatLng[]
        nome?: string
        lookat?: google.maps.LatLng
    }
}

// const { Option } = Select;

const DesenhaTalhaoNew: React.FC<TypesDesenhoTalhao> = (props) => {
    const { propriedade, update, atualizar, cultivavel, dataPolygon = { coordenadas: [] }, onClose } = props

    const [getPath, setPath] = useState<google.maps.LatLng[]>([])
    const [getAreatalhao, setGetAreatalhao] = useState<number>(0)
    const [getCenter, setCenter] = useState<google.maps.LatLng | google.maps.LatLngLiteral>({
        lat: -18.4590515,
        lng: -64.3517889,
    })

    const [getZoom, setZoom] = useState<number>(4)

    const [typeBusca, setTypeBusca] = useState(false)

    const [getlistUf, setListUf] = useState([])

    const [getlistCity, setListCity] = useState([])

    const [undoPolygon, setUndoPolygon] = useState([])
    const [redoPolygon, setRedoPolygon] = useState([])

    const [getLoadingBuscaCoord, setLoadingBuscaCoord] = useState(false)

    const [drawingPoints, setDrawingPoints] = useState<google.maps.LatLngLiteral[]>([])
    const [isDrawingMode, setIsDrawingMode] = useState(true)

    const [polygon, setPolygon] = useState<google.maps.Polygon>()
    const [kinksPoints, setKinksPoints] = useState<{ lat: number; lng: number }[]>([])


    const [encolher_card_localizacao, setEncolher_card_localizacao] = useState<boolean>(true);

    const [uf, setUf] = useState<string>('');
    const [cod_uf, setCod_Uf] = useState<number>();
    const [open_uf, setOpenUf] = useState<boolean>(false);

    const [cidade, setCidade] = useState<string>('');
    const [cod_cidade, setCod_cidade] = useState<number>();
    const [open_cidade, setOpenCidade] = useState<boolean>(false);

    const [is_coordenadas, setIs_coordenadas] = useState<boolean>(false);

    const [latitude, setLatitude] = useState<string>('');
    const [longitude, setLongitude] = useState<string>('');

    const [nome_talhao_criado, setNome_talhao_criado] = useState<string>('');
    const [area_talhao_criado, setArea_talhao_criado] = useState<string>('0.00');

    const [open_delete, setOpen_delete] = useState<boolean>(false);

    const [fake_loading, setFake_loading] = useState<boolean>(false);

    const mapRef = useRef(null)

    const listenersRef = useRef([])



    const onUnmount = useCallback(() => {
        listenersRef.current.forEach((lis) => lis.remove())
    }, [])

    const validateKinks = (coordinates: { lat: number; lng: number }[]) => {
        try {
            if (coordinates.length < 4) return [];
            const coords = coordinates.map((c) => [c.lng, c.lat]);
            coords.push(coords[0]);
            const poly = turfPolygon([coords]);
            const intersectKinks = kinks(poly);
            if (intersectKinks.features.length > 0) {
                return intersectKinks.features.map((feature) => ({
                    lng: feature.geometry.coordinates[0],
                    lat: feature.geometry.coordinates[1],
                }));
            }
            return [];
        } catch {
            return [];
        }
    }

    const updateArea = (coords: google.maps.LatLng[] | google.maps.LatLngLiteral[]) => {
        const ha = calculoAreaCoord([coords])
        setGetAreatalhao(ha)
        setArea_talhao_criado(String(ha))
    }

    const handleListUf = async () => {
        const response = await listUf()
        setListUf(response)
    }

    const handleUndo = () => {
        const old = [...undoPolygon]
        const index = undoPolygon.length - 1
        let newArray = []
        let newCoord = []
        old.forEach((data, i) => {
            if (data !== undefined) {
                if (index !== i) {
                    newArray = [...newArray, data]
                } else {
                    setRedoPolygon([...redoPolygon, data])
                    newCoord = [old[i - 1]]
                }
            }
        })

        polygon.setPaths(newCoord)
        const ha = calculoAreaCoord(newCoord)
        setGetAreatalhao(ha)
        setArea_talhao_criado(String(ha))
        setUndoPolygon(newArray)
    }

    const onLoadMap = () => {
        //
    }

    const handleRedo = () => {
        const old = [...redoPolygon]
        const index = redoPolygon.length - 1
        let newArray = []
        let newCoord = []
        old.forEach((data, i) => {
            if (data !== undefined) {
                if (index !== i) {
                    newArray = [...newArray, data]
                } else {
                    setUndoPolygon([...undoPolygon, data])
                    newCoord = [old[i]]
                }
            }
        })

        polygon.setPaths(newCoord)
        const ha = calculoAreaCoord(newCoord)
        setGetAreatalhao(ha)
        setArea_talhao_criado(String(ha))
        setRedoPolygon(newArray)
    }

    const handleResetDesenho = () => {
        setUndoPolygon([])
        setRedoPolygon([])
        setDrawingPoints([])
        setIsDrawingMode(false)
        setPath([])
        polygon?.setPaths([])
        setGetAreatalhao(0)
        setArea_talhao_criado('0.00')
        setNome_talhao_criado('')
        setKinksPoints([])
    }

    const handleMapClick = (e: google.maps.MapMouseEvent) => {
        if (!isDrawingMode || update > 0) return
        const latLng = e.latLng
        if (!latLng) return
        setDrawingPoints((prev) => [...prev, { lat: latLng.lat(), lng: latLng.lng() }])
    }

    const handleClosePolygon = () => {
        if (drawingPoints.length < 3) return

        const latLngs = drawingPoints.map((p) => new google.maps.LatLng(p.lat, p.lng))

        setPath(latLngs)
        setUndoPolygon([latLngs])
        polygon?.setPaths(latLngs)
        updateArea(latLngs)
        setKinksPoints(validateKinks(drawingPoints))
        setIsDrawingMode(false)
    }

    const handleRemoveLastPoint = () => {
        setDrawingPoints((prev) => prev.slice(0, -1))
    }

    const handleMarkerDragEnd = (index: number, e: google.maps.MapMouseEvent) => {
        if (!e.latLng) return
        setDrawingPoints((prev) =>
            prev.map((p, i) => (i === index ? { lat: e.latLng.lat(), lng: e.latLng.lng() } : p))
        )
    }

    const handleMouseUpPolygon = () => {
        const dados = polyGetPath(polygon)
        setUndoPolygon([...undoPolygon, dados])
        setPath(dados)
        setDrawingPoints(dados)
        const ha = calculoAreaCoord([dados])
        setGetAreatalhao(ha)
        setArea_talhao_criado(String(ha))
        setKinksPoints(validateKinks(dados))
    }

    const onFinish = async () => {
        try {
            setFake_loading(true);
            loadingAlert({ msg: 'Aguarde...', id: 'cadastro_talhao' })

            const polygonFinish = polyGetPath(polygon)
            const kml = geralKmlPolygon(polygonFinish, nome_talhao_criado)
            const cripto = btoa(kml)
            const arquivo = `data:@file/xml;base64,${cripto}`

            const dados = {
                nome: nome_talhao_criado,
                cod_propriedade: propriedade,
                arquivo,
                area: String(getAreatalhao),
                status: 1
            }

            if (update <= 0) {
                const response = cultivavel
                    ? await postTalhaoCultivavel(propriedade, dados)
                    : await postTalhao(propriedade, dados)
                if (response.status === 201) {
                    successAlert('Talhão cadastrado com sucesso!', 5000, 'cadastro_talhao')
                    atualizar(propriedade, '')
                    onClose(false);
                }
            } else {
                const response = cultivavel
                    ? await putTalhaoCultivavel(propriedade, update, dados)
                    : await putTalhao(propriedade, update, dados)
                if (response.status === 200) {
                    successAlert('Talhão atualizado com sucesso!', 5000, 'cadastro_talhao')
                    atualizar(propriedade, '')
                    onClose(false);
                }
            }
        } catch (error) {
            setFake_loading(false);
            if (error.response) {
                const { data } = error.response
                if (!data.error[0].field) {
                    errorAlert(data?.error ?? 'Falha ao registrar talhão', 5000, 'cadastro_talhao')
                } else {
                    data.error.forEach((item) => {
                        errorAlert(item?.msg?.[0] ?? 'Falha ao registrar talhão', 5000, 'cadastro_talhao')
                    })
                }
            } else {
                destroyAlert()
            }
        }
    }

    const onFinishCoord = () => {
        // data
    }

    const onFildesChangeCoord = () => {
        // data
    }

    const handleSelectedUF = async (data) => {
        setCidade('');
        setCod_cidade(null);
        const response = await buscaCidade('', data, '');
        setListCity(response);
    }

    useEffect(() => {
        if (cod_uf && Number(cod_uf) > 0) {
            handleSelectedUF(cod_uf);
        }
    }, [cod_uf])


    const handleClickCoord = () => {
        const lat = parseFloat(latitude)
        const lng = parseFloat(longitude)
        setCenter({ lat, lng })
        mapRef.current.state.map.zoom = 15
    }

    const handleClickCity = async () => {
        setLoadingBuscaCoord(true)

        const response = await buscaCidade('', '', cod_cidade)
        const resp = response?.[0]

        const coord = await axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${resp?.nome}+${resp?.uf_sigla}&key=${process.env.REACT_APP_TOKEN_GOOGLE_MAPS}`
        )
        // @ts-ignore
        const location = coord.data?.results?.[0]?.geometry?.location ?? { lat: -15.2326204, lng: -53.6972225 }
        const { lat, lng } = location

        setCenter({ lat, lng })
        setZoom(15)
        setLoadingBuscaCoord(false)
    }

    const handleChangeTypeCenter = (data) => {
        setTypeBusca(data)
    }

    useEffect(() => {
        if (dataPolygon.coordenadas.length > 0) {
            const coord = dataPolygon.coordenadas

            setPath(coord)
            setUndoPolygon([coord])
            const ha = calculoAreaCoord([coord])
            setGetAreatalhao(ha)
            setArea_talhao_criado(String(ha))
            setNome_talhao_criado(dataPolygon.nome ?? '')
            setZoom(12)
            setKinksPoints(validateKinks(coord.map((c) => {
                const pt = c as unknown as google.maps.LatLng
                return typeof pt.lat === 'function'
                    ? { lat: pt.lat(), lng: pt.lng() }
                    : { lat: (c as unknown as google.maps.LatLngLiteral).lat, lng: (c as unknown as google.maps.LatLngLiteral).lng }
            })))

            const center = centerMap(coord)
            setCenter(center)
        }
    }, [dataPolygon])

    useEffect(() => {
        setDrawingPoints([])
        setIsDrawingMode(true)
        setPath([])
        setGetAreatalhao(0)
        setArea_talhao_criado('0.00')
        setNome_talhao_criado('')
    }, [atualizar])

    useEffect(() => {
        handleListUf()
    }, [])

    const mapOptions: google.maps.MapOptions = {
        mapTypeId: 'hybrid',
        mapTypeControl: false,
        streetViewControl: false,
        draggableCursor: isDrawingMode && update <= 0 ? 'crosshair' : undefined,
    }

    return (
        <Content>
            <div className='Content__map'>
                <div className='Content__map__options' style={{ zIndex: 10 }}>
                    <TitleH3>Ir para localização</TitleH3>
                    <ButtonCustom
                        icon={<FontAwesomeIcon icon={encolher_card_localizacao ? faEyeSlash : faEye} />}
                        onClick={() => setEncolher_card_localizacao(!encolher_card_localizacao)}
                        type='secondary'
                        style={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    />
                    <div className='Content__map__options__inputs' style={{ display: encolher_card_localizacao ? 'none' : 'flex' }}>
                        <Switcher
                            label="Busca por Coordenadas"
                            isChecked={is_coordenadas}
                            trigger={setIs_coordenadas}
                        />
                        {is_coordenadas
                            ?
                            <>
                                <Input
                                    label="Latitude"
                                    value={latitude}
                                    onChange={setLatitude}
                                    placeholder='Latitude'
                                    icon={faLocationPinLock}
                                />
                                <Input
                                    label="Longitude"
                                    value={longitude}
                                    onChange={setLongitude}
                                    placeholder='Longitude'
                                    icon={faLocationPinLock}
                                />
                            </>
                            :
                            <>
                                <Select
                                    label="UF"
                                    value={uf}
                                    onChange={setUf}
                                    onChangeID={setCod_Uf}
                                    items={getlistUf}
                                    open={open_uf}
                                    trigger={setOpenUf}
                                    idItem='cod'
                                    descricaoItem='sigla'
                                    icon={faFlag}
                                    placeholder='Estado'
                                />
                                <Select
                                    label="Cidade"
                                    value={cidade}
                                    onChange={setCidade}
                                    onChangeID={setCod_cidade}
                                    items={getlistCity}
                                    open={open_cidade}
                                    trigger={setOpenCidade}
                                    idItem='cod'
                                    descricaoItem='nome'
                                    icon={faCity}
                                    placeholder='Cidade'
                                    disabled={!cod_uf}
                                />
                            </>
                        }
                        <ButtonCustom
                            icon={<FontAwesomeIcon icon={faSearch} />}
                            style={{ alignSelf: 'flex-start' }}
                            // loading={getLoadingBuscaCoord}
                            onClick={is_coordenadas ? handleClickCoord : handleClickCity}
                        >
                            Buscar
                        </ButtonCustom>
                    </div>
                </div>
                <div className='Content__map__options' style={{ top: encolher_card_localizacao ? 68 : 268 }}>
                    <TitleH3>Controle de desenho</TitleH3>

                    <Inline gap={4} style={{ marginTop: 8 }}>
                        <ButtonCustom
                            onClick={() => { handleUndo() }}
                            icon={<FontAwesomeIcon icon={faUndo} />}
                            title='Desfazer'
                            type='secondary'
                            disabled={undoPolygon.length <= 1}
                        />
                        <ButtonCustom
                            onClick={() => { handleRedo() }}
                            icon={<FontAwesomeIcon icon={faRedo} />}
                            title='Refazer'
                            type='secondary'
                            disabled={redoPolygon.length <= 0}
                        />
                        <DeleteButton
                            loading={false}
                            message={''}
                            open={open_delete}
                            trigger={setOpen_delete}
                            disabled={getPath.length <= 0 && drawingPoints.length <= 0}
                            onDelete={() => { handleResetDesenho(); setOpen_delete(false); }}
                            typeButtonTrigger="primary"
                            title="Tem certeza resetar o desenho dos polígonos?"
                        />
                        <ButtonCustom
                            onClick={() => {
                                if (isDrawingMode && drawingPoints.length >= 3) {
                                    handleClosePolygon()
                                } else {
                                    setIsDrawingMode((prev) => !prev)
                                    if (isDrawingMode) setDrawingPoints([])
                                }
                            }}
                            icon={<FontAwesomeIcon icon={faDrawPolygon} />}
                            type={isDrawingMode ? 'secondary' : 'primary'}
                            disabled={isDrawingMode && drawingPoints.length < 3}
                        >
                            {isDrawingMode ? 'Fechar polígono' : 'Iniciar desenho'}
                        </ButtonCustom>
                    </Inline>
                </div>
                <GoogleMap
                    ref={mapRef}
                    onLoad={onLoadMap}
                    onClick={handleMapClick}
                    options={mapOptions}
                    mapContainerStyle={{
                        width: '100%',
                        height: '81vh',
                    }}
                    center={getCenter}
                    zoom={getZoom}
                >
                    {isDrawingMode && drawingPoints.length > 0 && (
                        <>
                            <Polyline
                                path={drawingPoints}
                                options={{
                                    strokeColor: 'cyan',
                                    strokeWeight: 4,
                                    geodesic: false,
                                }}
                            />
                            {drawingPoints.map((point, index) => (
                                <Marker
                                    key={index}
                                    position={point}
                                    draggable={index !== 0}
                                    onDragEnd={(e) => handleMarkerDragEnd(index, e)}
                                    onClick={index === 0 && drawingPoints.length >= 3 ? handleClosePolygon : undefined}
                                    options={{
                                        icon: {
                                            path: google.maps.SymbolPath.CIRCLE,
                                            scale: index === 0 && drawingPoints.length >= 3 ? 9 : 6,
                                            fillColor: index === 0 && drawingPoints.length >= 3 ? '#00ffff' : 'cyan',
                                            fillOpacity: 1,
                                            strokeColor: index === 0 && drawingPoints.length >= 3 ? '#fff' : '#fff',
                                            strokeWeight: index === 0 && drawingPoints.length >= 3 ? 3 : 2,
                                        },
                                        cursor: index === 0 && drawingPoints.length >= 3 ? 'pointer' : 'grab',
                                    }}
                                />
                            ))}
                        </>
                    )}

                    <Polygon
                        onLoad={(data) => setPolygon(data)}
                        paths={getPath}
                        onMouseUp={handleMouseUpPolygon}
                        onUnmount={onUnmount}
                        options={{
                            fillColor: kinksPoints.length > 0 ? '#ff4d4f' : 'cyan',
                            strokeColor: kinksPoints.length > 0 ? '#ff4d4f' : 'cyan',
                            strokeWeight: 4,
                            fillOpacity: 0.45,
                            clickable: true,
                            draggable: false,
                            editable: getPath.length > 0,
                            geodesic: false,
                        }}
                    />

                    {kinksPoints.map((point, index) => (
                        <Marker
                            key={`kink_${index}`}
                            position={point}
                            title="Linha sobreposta!"
                            icon={{
                                path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
                                fillColor: '#ff0000',
                                fillOpacity: 1,
                                strokeColor: '#000',
                                strokeWeight: 1,
                                scale: 1,
                                labelOrigin: new window.google.maps.Point(0, -28),
                            }}
                            label={{ text: '!', color: 'white', fontWeight: 'bold' }}
                        />
                    ))}
                </GoogleMap>
            </div>

            <Box style={{ width: 300, minWidth: 300, height: 250 }} gap={16}>
                <TitleH3>Dados do talhão</TitleH3>

                <Input
                    label='Nome do talhão'
                    placeholder='Digite o nome do talhão'
                    icon={faMapLocation}
                    value={nome_talhao_criado}
                    onChange={setNome_talhao_criado}
                />

                <Input
                    label='Área (ha)'
                    placeholder='0.00 ha'
                    icon={faChartArea}
                    value={area_talhao_criado + ' ha'}
                    onChange={() => { }}
                    readOnly
                />

                <Inline justifyContent='space-between'>

                    <ButtonCustom
                        icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                        onClick={onFinish}
                        style={{ alignSelf: 'flex-start' }}
                        loading={fake_loading}
                        disabled={!nome_talhao_criado || getAreatalhao === 0 || kinksPoints.length > 0}
                    >
                        Gerar Talhão
                    </ButtonCustom>
                </Inline>

            </Box>
        </Content>
    )
}

export default DesenhaTalhaoNew
